export default __webpack_public_path__ + "static/media/9.f3865794.png";